import { Expose, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Container } from './Container'
import { Facility } from './Facility'
import { Place } from './Place'
import { Product } from './Product'
import { Sku } from './Sku'

export class Found {
  @Expose({ name: 'xid' })
  guid?: string

  @Type(() => Facility)
  facility?: Facility

  @Type(() => Product)
  product?: Product

  @Type(() => Sku)
  sku?: Sku

  @Type(() => Batch)
  batch?: Batch

  @Type(() => Container)
  container?: Container

  @Type(() => Place)
  place?: Place

  @Expose({ name: 'num_units' })
  numUnits?: string

  get objPath() {
    const objPath = []
    if (this.place) {
      objPath.push(...this.place.objPath)
    }
    if (this.container) {
      objPath.push(...this.container.objPath)
    }
    return objPath
  }
}
